import React, { Component } from "react";
import {
  fetchActiveSeason,
  listenActiveSeason,
  listenReceiptsByUser,
  listenEmailVerificationStatus,
  listenUserAuthState,
  pullUserData,
} from "./db/firebaseMethods";
// import {  listenAuthenticatedUserChanges, pullUsers, pullReportsOfWriter, pullAllReports } from "./firestoreMethods";
// import {
//   pullQuestions,
//   pullAnswers,
//   listenAuthenticatedUserChanges,
// } from "./db/FirebaseMethods";
// import { getServerDate } from "./db/FirebaseMethods";
// import { convertStringToDate, convertDateToString } from "./HelperFunctions";

const AppContext = React.createContext();

class AppProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      activeSeason: null,
    };
    this._unsubscribeSeason = null;
    this._unsubscribeReceipts = null;
  }

  componentDidMount() {
    listenUserAuthState(this.userSetter);
    this._subscribeSeason();
  }

  componentDidUpdate(prevProps, prevState) {
    const { user, activeSeason } = this.state;
    const userChanged = user?.uid !== prevState.user?.uid;
    const seasonChanged = activeSeason?.id !== prevState.activeSeason?.id;

    if (userChanged || seasonChanged) {
      if (this._unsubscribeReceipts) {
        this._unsubscribeReceipts();
        this._unsubscribeReceipts = null;
      }
      if (user?.uid && activeSeason?.id) {
        this._unsubscribeReceipts = listenReceiptsByUser(
          user.uid,
          activeSeason.id,
          (receipts) => {
            this.setState((prev) => ({
              user: prev.user ? { ...prev.user, activeSeasonReceipts: receipts } : null,
            }));
          }
        );
      }
    }
  }

  componentWillUnmount() {
    if (this._unsubscribeSeason) this._unsubscribeSeason();
    if (this._unsubscribeReceipts) this._unsubscribeReceipts();
  }

  _subscribeSeason = (user) => {
    if (this._unsubscribeSeason) this._unsubscribeSeason();
    this._unsubscribeSeason = listenActiveSeason(
      (res) => this.setState({ activeSeason: res }),
      user
    );
  };

  userSetter = async (u) => {
    if (u === null) {
      // Logout: developer sorgusunu bırak, normal sorguya dön
      this._subscribeSeason();
    } else if (this.state.user === null) {
      const data = await pullUserData(u.uid);
      u = { ...u, ...data };
      this._subscribeSeason(u?.role === "developer" ? u : undefined);
      // if(!u.emailVerified){// Login olduk ama email verified değilmiş, bunu da dinlemeye başlayalım, verify olduğu anda gerekli güncellemeyi yapalım:
      //   listenEmailVerificationStatus(async(verifiedUser)=>{
      //     console.log("id token sonrası setatate çalışacak: ", verifiedUser);
      //     this.setState({user: {...this.state.user, ...verifiedUser}});
      //   })
      // }
    }
    this.setState({ user: u });
  };

  refreshUserData = async () => {
    const userId = this.state.user?.uid;
    if (userId) {
      const newData = await pullUserData(userId);
      const newUser = { ...this.state.user, ...newData };
      this.setState({ user: newUser });
    }
  };

  setCentralState = (obj) => {
    this.setState(obj);
  };

  render() {
    const { setCentralState, refreshUserData, userSetter } = this;

    return (
      <AppContext.Provider
        value={{
          ...this.state,
          setCentralState,
          refreshUserData,
          userSetter,
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export default AppContext;

export { AppProvider };
